import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';

const AzureAuthentication = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" label="Name" />
            <TextInput source="client_id" label="Client ID" />
            <TextInput source="client_secret" label="Client secret" />
            <TextInput source="tenant_id" label="Tenant ID" />
            <TextInput source="subscription_id" label="Subscription ID" />
        </SimpleForm>
    </Create>
);

export default AzureAuthentication;